import { CONFIG } from '../../../config'
const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patio`

// BALANCA
export function urlGetBalancas(tpId) {
  return `${BASE_URL}/balancas/${tpId}`
}

export function urlGetBalancasActived(tpId) {
  return `${BASE_URL}/balancas-actived/${tpId}`
}

export const urlPostBalanca = `${BASE_URL}/balanca`

// BALANCA MOVIMENTACAO
export const urlGetBalancaMovimentacoes = `${BASE_URL}/balanca-movimentacoes`
export function urlPostBalancaMovimentacao(userId) {
  return `${BASE_URL}/balanca-movimentacao/${userId}`
}
export function urlPatchFinalizarBalancaMovimentacao(id) {
  return `${BASE_URL}/balanca-movimentacao/${id}/finalizar`
}

export function urlReportBalancaMovimentacaoTicket(movId) {
  const { CONFIG } = require('../../../config')
  const { ENVIROMENT } = CONFIG
  const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patio`
  return `${BASE_URL}/balanca-movimentacao/${movId}/ticket?t=${localStorage.getItem('t')}`
}

// TOMADA
export function urlGetTomadas(tpId) {
  return `${BASE_URL}/tomadas/${tpId}`
}
export function urlGetTomadasActived(tpId) {
  return `${BASE_URL}/tomadas-actived/${tpId}`
}
export const urlPostTomada = `${BASE_URL}/tomada`

// TOMADA UTILIZACAO
export const urlGetTomadaUtilizacoes = `${BASE_URL}/tomada-utilizacoes`
export function urlPostTomadaUtilizacao(userId) {
  return `${BASE_URL}/tomada-utilizacao/${userId}`
}
export function urlPatchFinalizarTomadaUtilizacao(id) {
  return `${BASE_URL}/tomada-utilizacao/${id}/finalizar`
}

export function urlReportUtilizacaoTomadaTicket(utlId) {
  const { CONFIG } = require('../../../config')
  const { ENVIROMENT } = CONFIG
  const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patio`
  return `${BASE_URL}/tomada-utilizacao/${utlId}/ticket?t=${localStorage.getItem('t')}`
}
